import { c as _c } from "react-compiler-runtime";
import React from "react";
import { FieldErrorContext, GroupContext, InputContext, LabelContext, Provider, TextAreaContext, TextContext, TextField as AriaTextField } from "react-aria-components";
import * as styles from "./Field.css.js";
import { InputSubtext } from "./InputSubtext.js";
import { Label } from "./Label.js";
import { FCTextFieldContext } from "./TextFieldContext.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const Description = t0 => {
  const $ = _c(12);
  const {
    description,
    textError
  } = t0;
  let t1;
  if ($[0] !== textError) {
    t1 = textError == null ? [] : [textError];
    $[0] = textError;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      customError: true,
      badInput: false,
      patternMismatch: false,
      rangeOverflow: false,
      rangeUnderflow: false,
      stepMismatch: false,
      tooLong: false,
      tooShort: false,
      typeMismatch: false,
      valid: false,
      valueMissing: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = {
      isInvalid: true,
      validationErrors: t1,
      validationDetails: t2
    };
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const fieldErrorContextProps = t3;
  if (textError != null) {
    let t4;
    if ($[5] !== description) {
      t4 = /*#__PURE__*/_jsx(InputSubtext, {
        text: description
      });
      $[5] = description;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== fieldErrorContextProps || $[8] !== t4) {
      t5 = /*#__PURE__*/_jsx(FieldErrorContext.Provider, {
        value: fieldErrorContextProps,
        children: t4
      });
      $[7] = fieldErrorContextProps;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let t4;
  if ($[10] !== description) {
    t4 = /*#__PURE__*/_jsx(InputSubtext, {
      text: description
    });
    $[10] = description;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
const BaseTextField = (t0, ref) => {
  const $ = _c(26);
  let children;
  let description;
  let label;
  let labelRight;
  let labelTooltip;
  let props;
  let t1;
  let validate;
  if ($[0] !== t0) {
    ({
      label,
      labelTooltip,
      description,
      orientation: t1,
      children,
      validate,
      labelRight,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = description;
    $[3] = label;
    $[4] = labelRight;
    $[5] = labelTooltip;
    $[6] = props;
    $[7] = t1;
    $[8] = validate;
  } else {
    children = $[1];
    description = $[2];
    label = $[3];
    labelRight = $[4];
    labelTooltip = $[5];
    props = $[6];
    t1 = $[7];
    validate = $[8];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  const name = props.name;
  const textError = props.isInvalid === true && typeof validate === "string" ? validate : undefined;
  const ariaValidate = typeof validate === "function" ? validate : undefined;
  const labelRef = React.useRef(null);
  let t2;
  if ($[9] !== orientation) {
    t2 = styles.base({
      orientation
    });
    $[9] = orientation;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== children || $[12] !== description || $[13] !== label || $[14] !== labelRight || $[15] !== labelTooltip || $[16] !== name || $[17] !== textError || $[18] !== validate) {
    t3 = innerProps => /*#__PURE__*/_jsxs(_Fragment, {
      children: [label != null && /*#__PURE__*/_jsxs("div", {
        className: styles.label,
        children: [/*#__PURE__*/_jsx(Label, {
          ref: labelRef,
          tooltip: labelTooltip,
          children: label
        }), labelRight != null && /*#__PURE__*/_jsx(Provider, {
          values: [[LabelContext, null], [InputContext, null], [TextAreaContext, null], [GroupContext, null], [TextContext, null], [FieldErrorContext, null]],
          children: labelRight
        })]
      }), /*#__PURE__*/_jsx(FCTextFieldContext.Provider, {
        value: {
          label,
          labelTooltip,
          description,
          validate,
          labelRef,
          name,
          textFieldProps: innerProps
        },
        children: /*#__PURE__*/_jsx("div", {
          className: styles.children,
          children: typeof children === "function" ? children(innerProps) : children
        })
      }), (description != null || textError != null || innerProps.isInvalid) && /*#__PURE__*/_jsx("div", {
        className: styles.description,
        children: /*#__PURE__*/_jsx(Description, {
          description: description,
          textError: textError
        })
      })]
    });
    $[11] = children;
    $[12] = description;
    $[13] = label;
    $[14] = labelRight;
    $[15] = labelTooltip;
    $[16] = name;
    $[17] = textError;
    $[18] = validate;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== ariaValidate || $[21] !== props || $[22] !== ref || $[23] !== t2 || $[24] !== t3) {
    t4 = /*#__PURE__*/_jsx(AriaTextField, {
      ...props,
      validate: ariaValidate,
      ref: ref,
      className: t2,
      children: t3
    });
    $[20] = ariaValidate;
    $[21] = props;
    $[22] = ref;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  return t4;
};
export const Field = /*#__PURE__*/React.forwardRef(BaseTextField);
//# sourceMappingURL=Field.js.map